<template>
  <div>
    <page-title :title="title"></page-title>
    <ul id="contact-list">
      <li>Phone: <a href="tel:530-556-5605">530-556-5605</a></li>
      <li>Email: <a href="mailto:jonathan@studio308.co">jonathan@studio308.co</a> or <a href="mailto:jonny@jonnypickett.com">jonny@jonnypickett.com</a></li>
      <li>Company Site: <a href="https://www.studio308.co">https://www.studio308.co</a></li>
    </ul>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  export default {
    name: 'contact',
    data () {
      return {
        title: 'Contact me'
      }
    },
    components: {
      PageTitle
    }
  }
</script>

<style>
#contact-list {
  list-style: none;
  padding-left: 0;
}
</style>



// WEBPACK FOOTER //
// Contact.vue?76446aaf